"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const MessageHidden = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.79 1.646c.21.422.21.973.21 2.074v5.64c0 1.101 0 1.652-.21 2.074a2 2 0 01-.896.895c-.422.211-.973.211-2.074.211H5l-2.417 1.934c-.818.654-1.227.981-1.57.986a1 1 0 01-.801-.385C0 14.804 0 14.28 0 13.232V3.72C0 2.62 0 2.068.21 1.646a2 2 0 01.896-.895c.422-.21.973-.21 2.074-.21h9.64c1.101 0 1.652 0 2.074.21a2 2 0 01.895.895zM8.535 4.682l.91-.915h-.005a5.656 5.656 0 00-6.478 2.9 5.71 5.71 0 001.635 1.949l1.419-1.414a2.056 2.056 0 012.52-2.52zm2.867.039l-.003-.003h.005l-.002.003zm0 0L9.986 6.132a2.057 2.057 0 01-2.52 2.52l-.91.915a5.656 5.656 0 006.49-2.9 5.74 5.74 0 00-1.643-1.946zM12 3.397l-.73-.73-7.27 7.27.73.73 7.27-7.27z",
  fill: "#ACB3BE"
}));
var _default = exports.default = MessageHidden;